export const HorizontalLine20 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="2" viewBox="0 0 20 2" fill="none">
            <path opacity="0.8" d="M19.3314 1.15771L0.983589 1.15771" stroke="white" strokeWidth="1.29696" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}